import React from "react";
import PropTypes from "prop-types";
import ServiceSelector from "./ServiceSelector";
import WorkflowActionLabel from "./WorkflowActionLabel";
import {WorkflowsContext} from "@web/hooks/context";

AppsServicesSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  action: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  excludeIndex: PropTypes.array,
};

function AppsServicesSelector(props) {
  const wtx = React.useContext(WorkflowsContext);

  if (!wtx.workflow) {
    return <div className="fat-chip primary">Input</div>;
  }

  return <div className="space space-center-y">
    <ServiceSelector
      onClick={(e) => props.onChange(e.key)}
      items={
      wtx.workflow?.steps?.map?.((action, index) => ({
        label: <WorkflowActionLabel
          action={action}
          className="space space-between"
          sequenceNumber={index + 1}
        />,
        value: action,
        key: index,
        disabled: props.excludeIndex?.includes(index),
      }))
      }
      text={
      <WorkflowActionLabel
        action={props.action}
        placeholder={props.placeholder || "Select a service"}
      />
      }
    />
  </div>
}

export default AppsServicesSelector;
